<template>
  <div class="personal-info">
    <div class="personal-info-header">
      <h5>個資聲明</h5>
    </div>
    <div class="personal-info-content">
      <div>電子收據歸戶功能：</div>
      <div>
        將已開立電子收據之資訊匯整至使用者身分識別資訊，以利使用者登入驗證後即可取得所有已歸戶之電子收據資料。
      </div>
      <div>依據個人資料保護法等相關規定，臺北市政府（以下簡稱本府）有義務告知以下事項：</div>
      <div>
        利用本府台北通使用電子收據歸戶功能，將提供您的「身分證號碼、出生年月日」予「臺北市政府電子收據系統」使用，並遵守個人資料保護法相關規定，保障使用者的個資。
      </div>
      <div>
        若您是對台北通或臺北市政府電子收據系統有任何疑問，請於上班時間撥打本府資訊局客服專線02-27208889轉分機8585，由專人為您服務。
      </div>
      <!-- <br />
      <ul class="list list-chinese-formal">
        <li>
          本服務使用者 (以下簡稱使用者)
          承諾遵守中華民國相關法規及使用網際網路之慣例，並同意不透過本服務從事侵害他人權益或違法之行為，包括但不限於：
          <ul class="list list-chinese-informal">
            <li>未經同意擅自摘錄或使用本服務內任何內容之全部或一部。</li>
            <li>干擾或中斷本服務系統運作。</li>
            <li>
              提供錯誤資訊進入本服務系統、冒用他人帳號或提供錯誤電子郵件帳號，或企圖誤導收件人而偽造寄件人資料。
            </li>
            <li>妨礙或干擾其他使用者使用本服務之行為。</li>
            <li>其他本府合理認為之不當行為。</li>
          </ul>
        </li>
        <li>
          個人資料蒐集方式及個資保護
          <ul class="list list-chinese-informal">
            <li>
              使用者同意下列事項：
              <ul class="list list-number">
                <li>本府蒐集並保留使用者提供之個人資料。</li>
                <li>本府蒐集並保留伺服器自行產生之相關紀錄(LOG)、使用時間及使用之瀏覽器等資訊。</li>
                <li>本府將所蒐集之個人資料用於維護、管理或改進本服務。</li>
              </ul>
            </li>
            <li>
              本府將依照個人資料保護法及本府網站「隱私權及資訊安全政策」保護使用者之個人資料。
            </li>
            <li>
              如符合下列事項，本府將揭露使用者之個人資料予政府機關、司法單位或第三方：
              <ul class="list list-number">
                <li>法律明文規定。</li>
                <li>為維護國家安全或增進公共利益所必要。</li>
                <li>為免除使用者之生命、身體、自由或財產上之危險。</li>
                <li>為防止他人權益之重大危害。</li>
                <li>
                  公務機關或學術研究機構基於公共利益為統計或學術研究而有必要，且資料經過提供者處理後或經蒐集者依其揭露方式無從識別特定之使用者。
                </li>
                <li>有利於使用者權益。</li>
                <li>經使用者同意。</li>
              </ul>
            </li>
            <li>
              本府將透過使用者所填寫的個人資料用以發送相關市政宣導資訊、提供市政相關服務或優惠權益資訊，使用者得拒絕是否接受特定資訊、服務或優惠。
            </li>
            <li class="text-danger">
              使用者如以其他服務系統（例如台北通等）之會員資料登入本服務，將依各應用服務會員約定條款方式進行個資蒐集、處理及利用之同意及個人資料應用授權。
            </li>
          </ul>
        </li>
        <li>
          責任範圍、免除與限制
          <ul class="list list-chinese-informal">
            <li>
              本服務如因環境變化（包括但不限於技術或政策變更）、系統維護或轉換之需要，本府得提前48小時公告變更、暫停、調整或終止本服務內容，使用者應自行注意本府之相關公告，本府無須因此對使用者負任何賠償責任。
            </li>
            <li>
              本服務如受地震、颱風、水災、火災、戰爭、政府行為、法令變更或第一類電信事業接續中斷等不可抗力之因素影響，本府得逕行依實際狀況變更、暫停、調整或終止本服務，無須對使用者負任何賠償責任。
            </li>
            <li>
              使用者終止使用本服務或本府終止提供本服務，本府將移除並刪除本服務內使用者之個人資料，如使用者須備份其個人資料，得於本服務終止前自行為之。
            </li>
            <li>
              本服務僅依使用者當下繳費情形而產製收據內容，如嗣後繳費狀況有所變更或使用者有其他特定要求或需求等而致收據內容變更，本府不負任何形式或內容之擔保或保證責任。
            </li>
            <li>
              使用者如自行於網際網路或其他方式散佈或擷取之各項資料及個人資料，使用者應自行負責其所涉及之各項法律責任。
            </li>
          </ul>
        </li>
        <li>
          準據法與管轄法院
          <ul class="list list-chinese-informal">
            <li>本規章以中華民國法律（不含涉外民事法律適用法或其他類似法規）為準據法。</li>
            <li>就本規章涉及之民事爭訟，使用者同意以臺灣臺北地方法院為第一審管轄法院。</li>
            <li>本規章若任何一部無效，不影響其他部份之效力。</li>
            <li>
              使用者透過本服務所為之違法行為，應由使用者自負民事或刑事等法律責任，本府於必要時得報請相關單位依法處理。
            </li>
          </ul>
        </li>
        <li>
          本府保留隨時修改本規章之權利，並於本服務首頁公告修改之內容，不另行通知各使用者。使用者於任何修改或變更後繼續使用本服務，視為已閱讀、瞭解並同意接受該等修改或變更。如使用者不同意本規章之修改內容，得終止使用本服務。
        </li>
      </ul> -->
    </div>
    <b-form-group class="personal-info-agreement">
      <b-form-checkbox v-model="agreement">本人已詳閱並同意以上個資聲明</b-form-checkbox>
    </b-form-group>
    <div class="personal-info-footer" v-if="isShowBtn">
      <b-button
        :variant="!agreement ? 'secondary' : 'primary'"
        :disabled="!agreement"
        class="mt-2 mb-5"
        @click="returnHome()"
        >收據歸戶</b-button
      >
    </div>
  </div>
</template>

<script>
import CommonApiMixin from '@/mixins/commonApi';
import ApiMixin from '@/mixins/api';

export default {
  name: 'PersonalInfo',

  mixins: [CommonApiMixin, ApiMixin],

  props: {
    isShowBtn: {
      type: Boolean,
      default: true,
    },
    reqData: {
      type: Object,
      default() {
        return {};
      },
    },
    token: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      localShow: this.show,
      agreement: false,
    };
  },

  watch: {
    agreement(val) {
      console.log('agreement-', val);
      this.$emit('changeAgreement', val);
    },
  },

  methods: {
    returnHome() {
      this.reqData.tokenTPass = this.token;
      // this.reqData.tokenTPass = 'fromTPITest';
      const url = '/GovEReceipt/FrontDeskService/UpdateTaipeiPass';
      const method = 'post';
      this.axiosServiceSend(this.reqData, url, method, 'UpdateTaipeiPass');
    },
    success(type, result) {
      switch (type) {
        case 'UpdateTaipeiPass':
          this.isShowMsg = true;
          this.$nextTick(() => {
            if (result.data.rtnCode === '0000') {
              this.$emit('changeMsg', 'success', result.data.msg, '', '歸戶完成');
            } else if (result.data.rtnCode === '8888') {
              const options = {
                btnName: '查看收據',
                isShowBtn: true,
              };
              this.$emit('changeMsg', 'info', result.data.msg, '', '歸戶錯誤', options);
            } else if (result.data.rtnCode === '9999') {
              this.$emit('changeMsg', 'error', result.data.msg, '', '歸戶失敗');
            }
          });
          break;
        default:
          break;
      }
      console.log('有資料');
    },
    fail(type, error) {
      switch (type) {
        case 'QrgetData':
          console.log(error);
          break;
        default:
          break;
      }
      this.apiLoading = false;
    },
  },
};
</script>
